/**
 * 受注一覧
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/allocate/entries/unspecified_allocations`

 const allocate_entry_unspecified_allocation = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * 配車計画 日付未定受注一覧
     * @return {Promise<unknown>}
     */
    index () {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH).then(data => {
          // let content = data.content
          // commit(types.DRIVER_DISPOSER, { content })
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},

 }

 export default allocate_entry_unspecified_allocation
